.pt-profile-menu {
  display: flex;
  box-sizing: border-box;
  min-height: 32px;
  cursor: pointer;
  border: none;
  text-decoration: none;

  &.disabled {
    opacity: 0.5;

    &:hover {
      cursor: not-allowed;
    }
  }

  color: var(--color-foreground-de-emp);

  &:not(.disabled):hover,
  &:not(.disabled):focus {
    background-color: var(--color-hover);
    outline: none;
  }

  &.active {
    box-shadow: inset 4px 0px 0px var(--color-foreground-highlight);
    color: var(--color-foreground-highlight);
    background-color: var(--color-background-raised);
  }

  >.content {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    >.active-icon {
      padding-left: $pad-xl;
    }

    >.text {
      flex: 1;
      font-family: $font-normal;
      padding-left: $pad-xxxl;
      padding-top: $pad-xs;
      padding-bottom: $pad-xs;
      font-size: $font-m-size;
      color: var(--color-foreground-de-emp);
      line-height: $font-m-line-height;

      &.selectable {
        padding-left: 44px;
      }

      >.heading {
        font-weight: $font-weight-default;

        &.selectable {
          margin-left: -6px;
        }
      }
    }

    >.submenu-icon {
      padding-right: 8px;
    }
  }
}
